module.exports = __webpack_public_path__ + "resource/img/radio01.b1e41d50.png";